import SectionedMultiSelect from './lib/sectioned-multi-select';

export default SectionedMultiSelect;